import { getDataMapper, mapArray, mapField } from "@/shared";

const toNumberOrNull = (value) => {
    if (value == null) return null;

    return Number(value);
};

const mapHealth = getDataMapper({
    score: mapField("score", toNumberOrNull),
    label: mapField("label"),
});

const mapMailing = getDataMapper({
    campaign: mapField("campaign"),
    subject: mapField("subject"),
    sentAt: mapField("sent_at"),
    opened: mapField("opened", Boolean),
    clicked: mapField("clicked", Boolean),
    status: mapField("status"),
});

const mapTariff = (tariff) => {
    if (!tariff) return null;

    if (typeof tariff === "string") return { title: tariff };

    return {
        id: tariff.id != null ? Number(tariff.id) : null,
        title: tariff.title ?? null,
    };
};

const mapMailings = (mailings) => {
    if (!Array.isArray(mailings)) return [];

    return mailings.map(mapMailing);
};

const mapHealthField = (health) => {
    if (!health) return null;

    return mapHealth(health);
};

export const mapBoardDirectorFromServer = getDataMapper({
    id: mapField("id", Number),
    fio: mapField("fio", (value) => value ?? ""),
    company: mapField("company"),
    phone: mapField("phone"),
    email: mapField("email"),
    login: mapField("login"),
    crmStageId: mapField("crm_stage_id", toNumberOrNull, {
        applyToNil: true,
    }),
    autoStageConst: mapField("auto_stage_const"),
    tariff: mapField("tariff", mapTariff, { applyToElements: false }),
    manager: mapField("manager"),
    lastVisit: mapField("last_visit"),
    health: mapField("health", mapHealthField, { applyToElements: false }),
    mrr: mapField("mrr", toNumberOrNull),
    ltv: mapField("ltv", toNumberOrNull),
    mailings: mapField("mailings", mapMailings, { applyToElements: false }),
});

export const mapBoardDirectorsFromServer = mapArray(mapBoardDirectorFromServer);

const mapBoardStageFromServer = getDataMapper({
    id: mapField("id", Number),
    const: mapField("const"),
    title: mapField("title"),
    color: mapField("color"),
    count: mapField("count", toNumberOrNull),
    cards: mapField("cards", mapBoardDirectorFromServer),
});

const mapBoardStagesFromServer = mapArray(mapBoardStageFromServer);

export const mapCrmBoardFromServer = (payload) => {
    if (!payload) {
        return { total: 0, stages: [] };
    }

    return {
        total: toNumberOrNull(payload.total) ?? 0,
        stages: mapBoardStagesFromServer(payload.stages ?? []) ?? [],
    };
};
